export default __webpack_public_path__ + "static/media/success.85383b87.svg";